import { render, staticRenderFns } from "./VaPageNotFoundSearch.vue?vue&type=template&id=a44b8a5c&"
import script from "./VaPageNotFoundSearch.vue?vue&type=script&lang=js&"
export * from "./VaPageNotFoundSearch.vue?vue&type=script&lang=js&"
import style0 from "./VaPageNotFoundSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports